import React from 'react';
import { motion } from 'framer-motion';
interface SectionWrapperProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
}
export function SectionWrapper({
  children,
  className = '',
  id
}: SectionWrapperProps) {
  return <section id={id} className={`py-20 md:py-32 px-6 md:px-12 lg:px-24 ${className}`} data-id="element-184">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} className="max-w-6xl mx-auto" data-id="element-185">
        {children}
      </motion.div>
    </section>;
}